import {createItem, createShopItem, updateShopItem} from "../../Store/Actions/item";
import {Button, Col, Drawer, Form, Input, InputNumber, Row} from "antd";
import React from "react";



class ItemDrawer extends React.Component {

    state = {
        loading: false
    };


    createKeywords = name => {
        const arrName = [];
        let curName = '';
        name.toLowerCase().split('').forEach(letter => {
            curName += letter;
            arrName.push(curName);
        });
        return arrName;
    }


    generateKeywords = values => {
        let { name, category } = values;
        if(this.props.item) {
            name = this.props.item.name;
            category = this.props.item.category;
        }
        const { company } = values;
        const com = company.length > 0 ? ` ${company}` : "";
        const keywordNameCategoryCompany = this.createKeywords(`${name} ${category}${com}`);
        const keywordNameCompanyCategory = this.createKeywords(`${name}${com} ${category}`);
        const keywordCategoryNameCompany = this.createKeywords(`${category} ${name}${com}`);
        const keywordCategoryCompanyName = this.createKeywords(`${category}${com} ${name}`);
        const keywordCompanyNameCategory = this.createKeywords(`${company} ${name} ${category}`);
        const keywordCompanyCategoryName = this.createKeywords(`${company} ${category} ${name}`);

        return [
            ...new Set([
                '',
                ...keywordNameCategoryCompany,
                ...keywordNameCompanyCategory,
                ...keywordCategoryNameCompany,
                ...keywordCategoryCompanyName,
                ...keywordCompanyNameCategory,
                ...keywordCompanyCategoryName
            ])
        ];
    }


    onFinish = values => {
        const { state, item, shopId, onClose } = this.props;
        this.setState({
            loading: true
        });
        let keywords = item.keywords ? item.keywords : [];
        if(!item.company && values.company && values.company.length > 0){
            keywords = this.generateKeywords(values);
        }
        if(state === "add") {
            createShopItem(shopId, item.id, {
                name: item.name,
                image: item.image,
                barcode: item.barcode ? item.barcode : null,
                category: item.category,
                company: item.company ? item.company : (values.company ? values.company : null),
                price: values.price,
                keywords: keywords
            }, res => {
                onClose();
                this.setState({
                    loading: false
                });
            })
        } else {
            let data = {
                price: values.price
            };
            if(!item.company && values.company && values.company.length > 0){
                data = {
                    price: values.price,
                    keywords: keywords,
                    company: values.company
                };
            }
            updateShopItem(shopId, item.id, data, res => {
                onClose();
                this.setState({
                    loading: false
                });
            });
        }
    };


    onCreate = values => {
        const { shopId, onClose } = this.props;
        this.setState({
            loading: true
        });
        let keywords = this.generateKeywords(values);

        createItem({
            name: values.name,
            image: values.image,
            category: values.category,
            keywords: keywords,
            barcode: values.barcode ? values.barcode : null,
            company: values.company ? values.company : null,
            price: values.price ? {
                sum: values.price.value ? values.price.value : null,
                count: values.price.value ? 1 : null,
                per: values.price.per ? values.price.per : null
            } : null
        }, res => {
            createShopItem(shopId, res, {
                name: values.name,
                image: values.image,
                barcode: values.barcode ? values.barcode : null,
                category: values.category,
                company: values.company ? values.company : null,
                price: values.price,
                keywords: keywords
            }, res => {
                this.setState({ loading: false })
                onClose();
            });
        });
    }

    render() {
        const { state, item, visible, onClose } = this.props;
        const { loading } = this.state;

        return (
            <div>
                { item ?
                    <div className="uk-padding-small uk-background-muted uk-border-rounded uk-margin-bottom">
                        <Row gutter={[16, 16]}>
                            <Col span={6}>
                                <div className="uk-flex uk-flex-middle">
                                    <img src={item.image} className="uk-height-small uk-width-small uk-border-rounded"/>
                                </div>
                            </Col>
                            <Col span={18}>
                                <div>
                                    <div>
                                        <Form initialValues={item} layout="vertical" hideRequiredMark onFinish={this.onFinish}>
                                            <h4 className="uk-h4 uk-margin-remove">
                                                { item.name }
                                            </h4>
                                            <p className="uk-p uk-margin-remove">
                                                <span className="uk-text-muted uk-text-bold">Category:</span> { item.category }
                                            </p>
                                            { item.company ?
                                                <p className="uk-p uk-margin-remove">
                                                    <span className="uk-text-muted uk-text-bold">Producer:</span> { item.company }
                                                </p>
                                                : null }

                                            { state === "add" ?
                                                <h4 className="uk-h4 color-green uk-margin-remove">
                                                    ~{ item.price.sum/item.price.count }₸
                                                </h4>
                                                :
                                                <h4 className="uk-h4 color-green uk-margin-remove">
                                                    { item.price.value + "₸ / " + item.price.per }
                                                </h4>
                                            }
                                            <div>
                                                <h4 className="uk-margin-top">

                                                    <Row gutter={4} className="uk-width-1-1">
                                                        <Col>
                                                            <Form.Item
                                                                name={["price", "value"]}
                                                                rules={[
                                                                    {
                                                                        type: 'number',
                                                                        min: 0
                                                                    },
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}
                                                                className="uk-width-1-1 uk-margin-remove"
                                                            >
                                                                { state === "add" ?
                                                                    <InputNumber width="100%" placeholder="Price" className="uk-width-1-1" />
                                                                    : <InputNumber placeholder="Price" className="uk-width-1-1" />}
                                                            </Form.Item>
                                                        </Col>
                                                        <Col>
                                                            <Form.Item
                                                                name={["price", "per"]}
                                                                rules={[
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}
                                                            >
                                                                <Input placeholder="Price per" />
                                                            </Form.Item>
                                                        </Col>
                                                        { item.company==null ?
                                                            <Col flex="auto">
                                                                <Form.Item
                                                                    name="company"
                                                                >
                                                                    <Input placeholder="Producer organization" />
                                                                </Form.Item>
                                                            </Col>
                                                            : null }
                                                    </Row>
                                                </h4>
                                            </div>
                                            <Form.Item>
                                                <Button disabled={loading} loading={loading} type="primary" htmlType="submit">
                                                    Submit
                                                </Button>
                                            </Form.Item>
                                        </Form>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    :
                    <div className="uk-padding-small uk-background-muted uk-border-rounded uk-margin-bottom">
                        <Row gutter={[16, 16]}>
                            <Col span={6}>
                                <div className="uk-flex uk-flex-middle">
                                    <img src="https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=jpg&quality=90&v=1530129081" className="uk-height-small uk-width-small uk-border-rounded"/>
                                </div>
                            </Col>
                            <Col span={18}>
                                <div>
                                    <div>
                                        <Form layout="vertical" hideRequiredMark onFinish={this.onCreate}>
                                            <h4 className="uk-h4 uk-margin-remove">
                                                <Form.Item
                                                    name="name"
                                                    rules={[
                                                        {
                                                            required: true
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder="Item name" />
                                                </Form.Item>
                                            </h4>
                                            <p>
                                                <Form.Item
                                                    name="image"
                                                    rules={[
                                                        {
                                                            required: true
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder="Item image URL" />
                                                </Form.Item>
                                            </p>
                                            <p className="uk-p uk-margin-remove">
                                                <Form.Item
                                                    name="category"
                                                    rules={[
                                                        {
                                                            required: true
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder="Item category" />
                                                </Form.Item>
                                            </p>
                                            <p>
                                                <Form.Item
                                                    name="company"
                                                >
                                                    <Input placeholder="Item company" />
                                                </Form.Item>
                                            </p>


                                            <div>
                                                <h4 className="uk-margin-top">

                                                    <Row gutter={4} className="uk-width-1-1">
                                                        <Col>
                                                            <Form.Item
                                                                name={["price", "value"]}
                                                                rules={[
                                                                    {
                                                                        type: 'number',
                                                                        min: 0
                                                                    },
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}
                                                                className="uk-width-1-1 uk-margin-remove"
                                                            >
                                                                <InputNumber width="100%" placeholder="Price" className="uk-width-1-1" />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col>
                                                            <Form.Item
                                                                name={["price", "per"]}
                                                                rules={[
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}
                                                            >
                                                                <Input placeholder="Price per" />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </h4>
                                            </div>
                                            <Form.Item>
                                                <Button disabled={loading} loading={loading} type="primary" htmlType="submit">
                                                    Submit
                                                </Button>
                                            </Form.Item>
                                        </Form>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                }
            </div>
        );
    }


}

export default ItemDrawer;



// WEBPACK FOOTER //
// ./src/Components/Items/ItemDrawer.js